import React, { Component } from "react";
import Header from "../../components/header/Header";
import { handleLandingScroll } from "../../utils/scroll";
import { trackPageview, track } from "../../utils/analytics";

/* counts 0 → target with an ease-out curve on mount */
class Count extends Component {
  constructor(props) {
    super(props);
    this.state = { v: 0 };
  }
  componentDidMount() {
    const target = this.props.to;
    const reduced =
      window.matchMedia &&
      window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (reduced) {
      this.setState({ v: target });
      return;
    }
    const dur = 1400;
    const t0 = performance.now();
    const step = (t) => {
      const k = Math.min(1, (t - t0) / dur);
      const e = 1 - Math.pow(1 - k, 3);
      this.setState({ v: Math.round(e * target) });
      if (k < 1) this.raf = requestAnimationFrame(step);
    };
    this.raf = requestAnimationFrame(step);
  }
  componentWillUnmount() {
    if (this.raf) cancelAnimationFrame(this.raf);
  }
  render() {
    return <>{this.state.v}</>;
  }
}

/* rotating circular "open for work" seal */
function Stamp() {
  return (
    <div className="stamp" aria-hidden="true">
      <svg viewBox="0 0 120 120">
        <defs>
          <path
            id="stamp-circ"
            d="M 60,60 m -44,0 a 44,44 0 1,1 88,0 a 44,44 0 1,1 -88,0"
          />
        </defs>
        <circle cx="60" cy="60" r="58" fill="var(--paper)" stroke="var(--ink)" strokeWidth="2" />
        <circle cx="60" cy="60" r="31" fill="none" stroke="var(--ink)" strokeWidth="1" />
        <text>
          <textPath xlinkHref="#stamp-circ" textLength="276">
            OPEN FOR WORK · Q3 2026 · PYTHON · BOTS ·
          </textPath>
        </text>
      </svg>
      <span className="core">✶</span>
    </div>
  );
}

/* infinite scrolling ticker — content duplicated for a seamless loop */
const MARQUEE_ITEMS = [
  "PYTHON",
  "WEB SCRAPING",
  "AUTOMATION",
  "BOTS",
  "DATA EXTRACTION",
  "FULL-STACK",
  "CLOUD INFRA",
  "166 PROJECTS SHIPPED",
  "EST. 2019",
];
function Marquee() {
  const group = (key) =>
    MARQUEE_ITEMS.map((m, i) => (
      <React.Fragment key={key + i}>
        <span className="item">{m}</span>
        <span className="sep">✶</span>
      </React.Fragment>
    ));
  return (
    <div className="marquee" aria-hidden="true">
      <div className="track">
        {group("a")}
        {group("b")}
      </div>
    </div>
  );
}

function SiteFooter() {
  return (
    <footer className="site-footer">
      <span>© 2026 MAANINOU WALID · CASABLANCA · GMT+1</span>
      <span>
        <a href="mailto:maaninou.walid@gmail.com">EMAIL</a>
        <a href="https://github.com/walidMaaninou">GITHUB</a>
        <a href="https://www.linkedin.com/in/walid-maaninou-86a844102/">LINKEDIN</a>
      </span>
    </footer>
  );
}

function FootSlab() {
  return (
    <div className="wrap">
      <div className="foot-slab" id="contact">
        <div className="inner">
          <h2>GOT WORK that should <em>run itself?</em></h2>
          <div>
            <h2 style={{ fontStyle: "italic", fontSize: "clamp(40px, 7vw, 88px)", margin: "0 0 16px" }}>Let's talk.</h2>
            <p>Available on LinkedIn and Gmail — I'll respond within 24 hours.</p>
            <div className="links">
              <a href="mailto:maaninou.walid@gmail.com">→ EMAIL <span>MAANINOU.WALID@GMAIL.COM</span></a>
              <a href="https://github.com/walidMaaninou">→ GITHUB <span>@WALIDMAANINOU</span></a>
              <a href="https://www.linkedin.com/in/walid-maaninou-86a844102/">→ LINKEDIN <span>IN/WALID-MAANINOU</span></a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

class Home extends Component {
  componentDidMount() {
    handleLandingScroll(this.props.location);
    trackPageview();
  }
  render() {
    return (
      <>
        <div className="grid-bg" />
        <Header theme={this.props.theme} />

        <div className="wrap">

          {/* HERO */}
          <section className="hero">
            <Stamp />
            <div className="reg-mark" style={{ left: 0, bottom: 18 }} />
            <div className="reg-mark" style={{ right: 0, top: 64 }} />
            <div className="label-strip">
              <span><b>INDEX</b></span>
              <span>CASABLANCA · 33.57°N 7.59°W · GMT+1</span>
              <span><b>OPEN</b> Q3 ’26</span>
            </div>

            <h1 className="huge">
              <span className="row">MAANINOU</span>
              <span className="row">WALID<span className="accent-bg">.</span></span>
              <span className="row indent"><span className="ital">automation</span></span>
              <span className="row indent"><span className="strike">&amp; bots.</span></span>
            </h1>

            <div className="sub-row">
              <p>
                <b>Python web scraping &amp; automation</b> | data extraction
                &amp; bots — with full-stack and cloud capabilities. I build
                end-to-end systems that turn the messy public web into clean,
                durable data products: scrapers, pipelines, dashboards, and
                the infrastructure that keeps it all quietly running.
              </p>
              <div className="meta-block">
                <div className="k">FACT SHEET</div>
                <div className="row"><span className="lab">DISCIPLINE</span><span>PY AUTOMATION &amp; BOTS</span></div>
                <div className="row"><span className="lab">SINCE</span><span>2019</span></div>
                <div className="row"><span className="lab">SHIPPED</span><span><Count to={166} /> PROJECTS</span></div>
                <div className="row"><span className="lab">DOMAINS</span><span>03</span></div>
                <div className="row"><span className="lab">REPLY</span><span>&lt; 24H</span></div>
              </div>
            </div>

            <div className="cta-row">
              <a className="primary" href="#/projects" onClick={() => track("cta_see_work", { location: "home_hero" })}>SEE THE WORK <span className="arrow">→</span></a>
              <a href="mailto:maaninou.walid@gmail.com" onClick={() => track("cta_email", { location: "home_hero" })}>SEND EMAIL <span className="arrow">↗</span></a>
              <a href="#/cv" onClick={() => track("cta_see_cv", { location: "home_hero" })}>SEE THE CV <span className="arrow">→</span></a>
            </div>
          </section>

          {/* MARQUEE */}
          <Marquee />

          {/* STACK — 3 DOMAINS (no blockchain) */}
          <section className="section" id="stack">
            <div className="section-head">
              <h2 className="section-title">THREE <em>domains</em></h2>
              <div className="meta"><b>03</b><br/>OVERLAPPING</div>
            </div>

            <div className="skills">
              <div className="skill highlight full">
                <div className="id"><span>01 / PYTHON AUTOMATION, SCRAPING &amp; BOTS</span><span className="pill">PRIMARY</span></div>
                <h3>AUTOMATE.<br/><em>scrape.</em> deliver.</h3>
                <p>Data extraction and bots for online databases, social media, and online marketplaces (Amazon, Facebook). Production-ready, anti-bot resilient, observable.</p>
                <p>Plus AI on top when it earns its keep — Computer Vision and NLP for the harder unstructured cases.</p>
                <div className="stack">
                  <span>python</span><span>scrapy</span><span>playwright</span><span>tensorflow</span><span>keras</span><span>pytorch</span>
                </div>
              </div>

              <div className="skill">
                <div className="id"><span>02 / FULL STACK</span><span className="pill">OFTEN</span></div>
                <h3>FRONT.<br/><em>and back.</em></h3>
                <p>Responsive front-ends with React / Redux.</p>
                <p>Application backends in Node, Express, Django and Flask. The connective tissue between data and humans.</p>
                <div className="stack">
                  <span>html</span><span>css</span><span>javascript</span><span>react</span><span>node</span><span>django</span>
                </div>
              </div>

              <div className="skill">
                <div className="id"><span>03 / CLOUD INFRA</span><span className="pill">OFTEN</span></div>
                <h3>BORING<br/><em>infra.</em></h3>
                <p>Multi-cloud experience. VMs + DB integration.</p>
                <p>Deep-learning models in the cloud, served to mobile. Streaming jobs between DB and server on GCP / AWS.</p>
                <div className="stack">
                  <span>gcp</span><span>aws</span><span>azure</span><span>firebase</span><span>postgres</span><span>docker</span><span>k8s</span>
                </div>
              </div>
            </div>
          </section>

          {/* WORK */}
          <section className="section" id="work">
            <div className="section-head">
              <h2 className="section-title">SELECTED <em>work</em></h2>
              <div className="meta"><b>05</b> / 166 SHIPPED</div>
            </div>

            <div className="proj-list">
              <div className="proj">
                <div className="num">01</div>
                <div>
                  <div className="name">Browser automation <em>reliability &amp; recovery</em></div>
                  <div className="desc">Diagnosed and rebuilt a failing browser-automation suite on Azure, restoring stable production runs and engaging on long-term maintenance for an automation agency's core pipelines.</div>
                </div>
                <div className="tech"><span>python</span><span>playwright</span><span>azure</span></div>
                <div className="stat"><span className="yr">2026</span><span className="done">SHIPPED</span></div>
              </div>

              <div className="proj">
                <div className="num">02</div>
                <div>
                  <div className="name">Web3 AI <em>data agent framework</em></div>
                  <div className="desc">Shipped AI-driven data agents for a web3 platform — connecting to live data sources, structuring their output, and exposing them as composable tools for the broader agent ecosystem.</div>
                </div>
                <div className="tech"><span>python</span><span>web3</span><span>llm</span></div>
                <div className="stat"><span className="yr">2026</span><span className="done">SHIPPED</span></div>
              </div>

              <div className="proj">
                <div className="num">03</div>
                <div>
                  <div className="name">Instagram influencer <em>data extraction</em></div>
                  <div className="desc">Extracts structured profile data — bios, follower counts, verification — from large Instagram accounts at scale (600k+ followers per target), with cost-aware account-by-account batching.</div>
                </div>
                <div className="tech"><span>python</span><span>instagram</span><span>s3</span></div>
                <div className="stat"><span className="yr">2026</span><span className="done">SHIPPED</span></div>
              </div>

              <div className="proj">
                <div className="num">04</div>
                <div>
                  <div className="name">Classifieds scraping &amp; <em>data reconciliation</em></div>
                  <div className="desc">Scrapes Dubizzle and YallaMotor at scale, reconciles listings into a shared ontology, and ships with anti-bot bypass plus a CI-tested pipeline for reliable, repeatable runs.</div>
                </div>
                <div className="tech"><span>python</span><span>playwright</span><span>ci</span></div>
                <div className="stat"><span className="yr">2026</span><span className="done">SHIPPED</span></div>
              </div>

              <div className="proj">
                <div className="num">05</div>
                <div>
                  <div className="name">Multi-store <em>Shopify data pipeline</em></div>
                  <div className="desc">A Python scraper that extracts location, product, and stock data from multiple Shopify storefronts via undocumented endpoints, packaged for periodic execution on AWS Lambda with S3 output.</div>
                </div>
                <div className="tech"><span>python</span><span>aws lambda</span><span>s3</span></div>
                <div className="stat"><span className="yr">2024</span><span className="done">SHIPPED</span></div>
              </div>
            </div>

            <p style={{ marginTop: 18, fontFamily: "'JetBrains Mono', monospace", fontSize: 12, textTransform: "uppercase", letterSpacing: ".06em", textAlign: "center" }}>
              <a className="inline" href="#/projects?to=catalogue">→ SEE THE FULL CATALOGUE</a>
            </p>
          </section>
        </div>

        {/* BIG QUOTE */}
        <div className="wrap">
          <div className="quote-slab">
            <div className="inner">
              <q>A scraper isn't done when it runs once. It's done when it runs for a <em>year</em> without me.</q>
              <cite>— OPERATING PRINCIPLE</cite>
            </div>
          </div>
        </div>

        <FootSlab />
        <SiteFooter />
      </>
    );
  }
}

export default Home;
